import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

export function fmtStorageBytes(bytes) {
  const n = Number(bytes) || 0;
  if (n === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(units.length - 1, Math.floor(Math.log(n) / Math.log(1024)));
  return `${(n / 1024 ** i).toFixed(i === 0 ? 0 : i < 2 ? 1 : 2)} ${units[i]}`;
}

/**
 * Barra de uso S3 vs límite asignado (panel admin).
 */
export default function RetailPhotosStorageBar({
  totalBytes = 0,
  storageLimitMb = 500,
  fileCount = 0,
  loading = false,
  compact = false,
}) {
  const limitBytes = Math.max(1, (Number(storageLimitMb) || 500) * 1024 * 1024);
  const used = Math.max(0, Number(totalBytes) || 0);
  const pct = Math.min(100, (used / limitBytes) * 100);
  const barColor = pct > 85 ? 'error' : pct > 60 ? 'warning' : 'primary';

  if (loading) {
    return compact
      ? <Skeleton width={80} height={20} />
      : <Skeleton variant="rounded" height={36} />;
  }

  if (compact) {
    return (
      <Typography variant="caption" fontWeight={600} sx={{ whiteSpace: 'nowrap' }}>
        {fmtStorageBytes(used)} / {storageLimitMb} MB
      </Typography>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
        <Typography variant="body2" fontWeight={600}>
          {fmtStorageBytes(used)} usados
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {fileCount} {fileCount === 1 ? 'imagen' : 'imágenes'} · límite {storageLimitMb} MB
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={pct}
        color={barColor}
        sx={{ height: 6, borderRadius: 3 }}
      />
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.25, display: 'block' }}>
        {pct.toFixed(1)}% del cupo asignado
      </Typography>
    </Box>
  );
}
